import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBitwardenComponent } from './simple-icons-bitwarden.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBitwardenComponent ],
    exports:      [ SimpleIconsBitwardenComponent ],
    bootstrap:    []
})
export class SimpleIconsBitwardenModule {}
